<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.inputQuantity"
            :error-messages="inputQuantityErrors"
            :label="$t('profile.tool.inputquantity')"
            required
            @input="$v.item.inputQuantity.$touch()"
            @blur="$v.item.inputQuantity.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.outputQuantity"
            :error-messages="outputQuantityErrors"
            :label="$t('profile.tool.outputquantity')"
            required
            @input="$v.item.outputQuantity.$touch()"
            @blur="$v.item.outputQuantity.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.heater"
            :error-messages="heaterErrors"
            :label="$t('profile.tool.heater')"
            @input="$v.item.heater.$touch()"
            @blur="$v.item.heater.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.model"
            :error-messages="modelErrors"
            :label="$t('profile.tool.model')"
            @input="$v.item.model.$touch()"
            @blur="$v.item.model.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.optionSubTool"
            :error-messages="optionSubToolErrors"
            :label="$t('profile.tool.optionsubtool')"
            @input="$v.item.optionSubTool.$touch()"
            @blur="$v.item.optionSubTool.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialMediumSelectItems"
            v-model="item.materialMedium"
            :items="materialMediumSelectItems"
            :error-messages="materialMediumErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.tool.materialmedium')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialFeedSpecSelectItems"
            v-model="item.materialFeedSpec"
            :items="materialFeedSpecSelectItems"
            :error-messages="materialFeedSpecErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.tool.materialfeedspec')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="nozzleTypeSelectItems"
            v-model="item.nozzleType"
            :items="nozzleTypeSelectItems"
            :error-messages="nozzleTypeErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.tool.nozzletype')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>


      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="toolsSelectItems"
            v-model="item.tools"
            :items="toolsSelectItems"
            :error-messages="toolsErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.tool.tools')"
            multiple
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
<!--
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-model="item.toolHead"
            :items="toolHeadSelectItems"
            :error-messages="toolHeadErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('toolHead')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
!-->
      </v-row>


    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'ToolHeadSubForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.materialMediumGetSelectItems();
      this.materialFeedSpecGetSelectItems();
      this.nozzleTypeGetSelectItems();
      this.toolsGetSelectItems();
      this.toolHeadGetSelectItems();
  },
  data() {
    return {
        inputQuantity: null,
        outputQuantity: null,
        heater: null,
        model: null,
        optionSubTool: null,
        materialMedium: null,
        materialFeedSpec: null,
        nozzleType: null,
        tools: null,
        toolHead: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_materialmedium ||
         this.isLoading_materialfeedspec ||
         this.isLoading_tool ||
         this.isLoading_toolhead ||
         this.isLoading_nozzletype
       );
    },
      ...mapFields('materialmedium', {
        materialMediumSelectItems: 'selectItems',
        isLoading_materialmedium : 'isLoading'
      }),
      ...mapFields('materialfeedspec', {
        materialFeedSpecSelectItems: 'selectItems',
        isLoading_materialfeedspec : 'isLoading'
      }),
      ...mapFields('nozzletype', {
        nozzleTypeSelectItems: 'selectItems',
        isLoading_nozzletype : 'isLoading'
      }),
      ...mapFields('tool', {
        toolsSelectItems: 'selectItems',
        isLoading_tool : 'isLoading'
      }),
      ...mapFields('toolhead', {
        toolHeadSelectItems: 'selectItems',
        isLoading_toolhead : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    inputQuantityErrors() {
      const errors = [];

      if (!this.$v.item.inputQuantity.$dirty) return errors;

      has(this.violations, 'inputQuantity') && errors.push(this.violations.inputQuantity);

      !this.$v.item.inputQuantity.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    outputQuantityErrors() {
      const errors = [];

      if (!this.$v.item.outputQuantity.$dirty) return errors;

      has(this.violations, 'outputQuantity') && errors.push(this.violations.outputQuantity);

      !this.$v.item.outputQuantity.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    heaterErrors() {
      const errors = [];

      if (!this.$v.item.heater.$dirty) return errors;

      has(this.violations, 'heater') && errors.push(this.violations.heater);


      return errors;
    },
    modelErrors() {
      const errors = [];

      if (!this.$v.item.model.$dirty) return errors;

      has(this.violations, 'model') && errors.push(this.violations.model);


      return errors;
    },
    optionSubToolErrors() {
      const errors = [];

      if (!this.$v.item.optionSubTool.$dirty) return errors;

      has(this.violations, 'optionSubTool') && errors.push(this.violations.optionSubTool);



      return errors;
    },
    materialMediumErrors() {
      const errors = [];

      if (!this.$v.item.materialMedium.$dirty) return errors;

      has(this.violations, 'materialMedium') && errors.push(this.violations.materialMedium);


      return errors;
    },
    materialFeedSpecErrors() {
      const errors = [];

      if (!this.$v.item.materialFeedSpec.$dirty) return errors;

      has(this.violations, 'materialFeedSpec') && errors.push(this.violations.materialFeedSpec);


      return errors;
    },
    nozzleTypeErrors() {
      const errors = [];

      if (!this.$v.item.nozzleType.$dirty) return errors;

      has(this.violations, 'nozzleType') && errors.push(this.violations.nozzleType);


      return errors;
    },
    toolsErrors() {
      const errors = [];

      if (!this.$v.item.tools.$dirty) return errors;

      has(this.violations, 'tools') && errors.push(this.violations.tools);


      return errors;
    },
    toolHeadErrors() {
      const errors = [];

      if (!this.$v.item.toolHead.$dirty) return errors;

      has(this.violations, 'toolHead') && errors.push(this.violations.toolHead);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        materialMediumGetSelectItems: 'materialmedium/fetchSelectItems'
      }),
      ...mapActions({
        materialFeedSpecGetSelectItems: 'materialfeedspec/fetchSelectItems'
      }),
      ...mapActions({
        nozzleTypeGetSelectItems: 'nozzletype/fetchSelectItems'
      }),
      ...mapActions({
        toolsGetSelectItems: 'tool/fetchSelectItems'
      }),
      ...mapActions({
        toolHeadGetSelectItems: 'toolhead/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      inputQuantity: {
        required,
      },
      outputQuantity: {
        required,
      },
      heater: {
      },
      model: {
      },
      optionSubTool: {

      },
      materialMedium: {
      },
      materialFeedSpec: {
      },
      nozzleType: {
      },
      tools: {
      },
      toolHead: {
      },
    }
  }
};
</script>
